module.exports = __webpack_public_path__ + "static/signature-821c6fc33992cb29078848021e165500.png";